import React, { PureComponent, PropTypes } from 'react';

export default class BookingLabelValueItem extends PureComponent {
    static propTypes = {
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        children: PropTypes.node,
    }

    render() {
        const clickableCssClass = this.props.onClick ? `clickable` : ``;

        return (
            <div className="booking-left-right-item">
                <h2 className="left-item">{this.props.label}</h2>
                <h2 className={`right-item ${clickableCssClass}`} onClick={this.props.onClick}>{this.props.children}</h2>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Booking/BookingLabelValueItem.jsx